import { useParams } from 'react-router-dom'

import { ShowPageDocument, TasksValueObjectsTaskIdentifierEnum } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import TaskElement from 'modules/tasks/components/TaskElement'

const ShowPage = () => {
  const params = useParams()
  const { taskId, identifier } = params
  const { navigation } = useNavigation()
  const back = navigation.tasks.fullPath()

  const { data, loading } = useQuery(ShowPageDocument)
  const canEmployeeManageAnyEmployeeFolder =
    data?.documents._policies.employeeManageAnyEmployeeFolder.can ?? false

  return (
    <TaskElement
      identifier={identifier as TasksValueObjectsTaskIdentifierEnum} // eslint-disable-line no-type-assertion/no-type-assertion
      taskId={Number(taskId)}
      back={back}
      contractVersions={contractVersions}
      canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
      loading={loading}
    />
  )
}

export default ShowPage
